
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/washington-traffic-tickets",
      function () {
        return require("private-next-pages/washington-traffic-tickets.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/washington-traffic-tickets"])
      });
    }
  